import styled from "styled-components";
export const InfoBoxDiv = styled.div<{ isClickable: boolean }>`
  span {
    color: #353752;
    font-weight: normal;
  }
  margin-top: 14px;
  white-space: nowrap;
  margin-bottom: 23px;
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "auto")};
  h2 {
    text-align: center;
    font-size: 20px;
  }
`;
